var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('ion-footer',[(_vm.showMessage)?_c('ion-note',[_c('p',{staticStyle:{"margin":"10px"}},[_vm._v(" "+_vm._s(_vm.footerTitle)+" ")])]):_vm._e(),_c('ion-toolbar',[_c('ion-button',{attrs:{"disabled":!_vm.enableSubmitButton},on:{"click":_vm.submitButtonAction}},[_vm._v("Submit")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }